<!-- eslint-disable import-alias/import-alias -->
<script lang="ts" setup>
import BankId from './components/BankId.vue';
import PasswordLogin from './components/PasswordLogin.vue';
import SSOLogin from './components/SSOLogin.vue';
import { LoginType, useLoginStore } from '@/login/stores/useLoginStore';
import { storeToRefs } from 'pinia';
import TemplateLogin from '@/views/newlogin/templates/TemplateLogin.vue';
import { computed } from 'vue';
import LanguageSwitcherDropDown from '@/components/LanguageSwitcherDropDown.vue';
import SelectInstance from '../SelectInstance.vue';
import TemplateLoginCard from './templates/TemplateLoginCard.vue';
import Progressbar from '@/components/common/Progressbar.vue';
import SelectLoginMethod from './components/SelectLoginMethod.vue';
import { BankIDStatus } from '@sysarb/sysarb-types/services/v1/login';

const loginStore = useLoginStore();
const { loginType, isLoggedIn, isInstanceSelected, instanceCount, instancesLoading, bankIdStatus, forgotPassword } = storeToRefs(loginStore);

const bankIdNotActive = computed(() => bankIdStatus.value === BankIDStatus.None);
</script>

<template>
    <TemplateLogin>
        <SelectInstance v-if="!isInstanceSelected && isLoggedIn && instancesLoading === 0" />
        <TemplateLoginCard v-else-if="instancesLoading > 0 && isLoggedIn">
            <SStack vertical gap="5">
                <SText>{{ $t('system.loggingIn') }}</SText>
                <Progressbar :total="instanceCount" :success="instanceCount - instancesLoading" />
            </SStack>
        </TemplateLoginCard>
        <TemplateLoginCard v-else-if="!isLoggedIn">
            <PasswordLogin v-if="loginType === LoginType.Password" />
            <BankId v-if="loginType === LoginType.BankId" />
            <SSOLogin v-if="loginType === LoginType.SSO" />
            <SelectLoginMethod v-if="bankIdNotActive && forgotPassword === false" />
            <LanguageSwitcherDropDown />
        </TemplateLoginCard>
    </TemplateLogin>
</template>
